export default __webpack_public_path__ + "static/media/season.2ba39bae.svg";